<template>
  <div class="user-request-tab">
    <div v-if="configLoading" class="d-flex align-items-center justify-content-center gap-2 text-muted small py-4">
      <i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
    </div>
    <div v-else-if="configError" class="text-center text-danger small py-4">{{ configError }}</div>
    <!-- Isian User (FORM01) item terpilih, lihat saja. Data & state form milik dialog sendiri (hasil fetch detailEmcrItem),
         TIDAK menulis ke mcrItem -> tidak ikut payload Save Cataloguer (FORM02). -->
    <McrItemFormDialog v-else-if="userFormConfig" ref="itemForm" inline readonly :form-config="userFormConfig" :mcr-type="mcrType" />
  </div>
</template>

<script>
import api from "@/helpers/api";
import formConfigService from "@/services/materialCatalogingRequest/formConfigService";
import formConfigHelper from "@/helpers/New_formConfig";
import McrItemFormDialog from "../../McrItemFormDialog.vue";

// Form isian User. Config-nya dimuat tab ini sendiri (BUKAN lewat store mcrDetail.formConfig -- itu config FORM02 Cataloguer),
// overlay company di-resolve BE dari company user, sama seperti FORM02. Kapan tab ini tampil diatur FORM02 tab `user_request`.
const USER_FORM_CODE = "FORM01";

export default {
  name: "UserRequestTab",
  components: { McrItemFormDialog },
  props: {
    // Item terpilih New_CataloguerForm -- cuma dibaca mcr_item_code-nya
    mcrItem: { type: Object, default: null },
    mcrType: { type: String, default: "" }
  },
  data() {
    return {
      userFormConfig: null,
      configLoading: false,
      configError: ""
    };
  },
  watch: {
    "mcrItem.mcr_item_code"() {
      this.openItem();
    }
  },
  async mounted() {
    await this.loadUserFormConfig();
    this.openItem();
  },
  methods: {
    async loadUserFormConfig() {
      this.configLoading = true;
      this.configError = "";
      try {
        const res = await api(this, formConfigService.New_getFormConfig({ form_code: USER_FORM_CODE }), false);
        this.userFormConfig = formConfigHelper.normalizeFormConfig(res?.data?.data || res?.data);
      } catch (error) {
        this.configError = "Failed to load User Request form.";
      } finally {
        this.configLoading = false;
      }
    },
    // Detail item diambil & di-hydrate dialog sendiri (openForEdit -> requestListService.detailEmcrItem).
    openItem() {
      const code = this.mcrItem?.mcr_item_code;
      if (!code || !this.userFormConfig) return;
      this.$nextTick(() => this.$refs.itemForm?.openForEdit(code));
    }
  }
};
</script>
